/* ============================================================
   Mother's Day 2026 — Landing page behaviors
   - Countdown to order deadline
   - FAQ expand/collapse (native <details> + class toggle for +/x rotation)
   - Smooth scroll for in-page anchors
   - Scarcity counter updater (reads from data-remaining attr or window.MD_REMAINING)
   ============================================================ */
(function () {
  "use strict";

  /* ---- Config — these are rendered by the Liquid template ---- */
  // window.MD_DEADLINE and window.MD_REMAINING are set inline in the template.
  var DEADLINE = window.MD_DEADLINE || "2026-05-09T12:00:00-04:00";
  var REMAINING = typeof window.MD_REMAINING === "number" ? window.MD_REMAINING : null;

  /* ---- Scarcity ---- */
  function applyRemaining() {
    if (REMAINING === null) return;
    var els = document.querySelectorAll("[data-remaining]");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var existing = el.textContent || "";
      if (existing.indexOf("remaining") !== -1) {
        el.textContent = REMAINING + " remaining";
      } else {
        el.textContent = String(REMAINING);
      }
    }
  }

  /* ---- Countdown ---- */
  function startCountdown() {
    var target = new Date(DEADLINE).getTime();
    if (isNaN(target)) return;
    var els = {
      d: document.querySelector('[data-cd="d"]'),
      h: document.querySelector('[data-cd="h"]'),
      m: document.querySelector('[data-cd="m"]'),
      s: document.querySelector('[data-cd="s"]')
    };
    function pad(n) { return String(n).padStart(2, "0"); }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (els.d) els.d.textContent = pad(d);
      if (els.h) els.h.textContent = pad(h);
      if (els.m) els.m.textContent = pad(m);
      if (els.s) els.s.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- FAQ — toggle is-open class on <details> so the +/x icon rotates ---- */
  function wireFAQ() {
    var items = document.querySelectorAll(".faq__item");
    items.forEach(function (d) {
      d.addEventListener("toggle", function () {
        d.classList.toggle("is-open", d.open);
      });
      if (d.open) d.classList.add("is-open");
    });
  }

  /* ---- Smooth scroll for in-page anchors ---- */
  function wireSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href");
        if (id.length > 1) {
          var el = document.querySelector(id);
          if (el) {
            e.preventDefault();
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    });
  }

  /* ---- Boot ---- */
  function boot() {
    applyRemaining();
    startCountdown();
    wireFAQ();
    wireSmoothScroll();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
